import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import { PageRenderer } from "../components/common/PageRenderer";
import styles from "./StaticPage.module.css";

export default function TermsPage() {
  return (
    <>
      <Navbar />
      <main className={styles.main}>
        <div className="container">
          <h1 className={styles.title}>Terms &amp; Conditions</h1>
          <PageRenderer pageKey="termsAndConditions" />
        </div>
      </main>
      <Footer />
    </>
  );
}
